import { render, staticRenderFns } from "./sitecreationform.vue?vue&type=template&id=84998ed6"
import script from "./sitecreationform.vue?vue&type=script&lang=js"
export * from "./sitecreationform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports